import { render, staticRenderFns } from "./ShowSalePerson.vue?vue&type=template&id=7b964abb"
import script from "./ShowSalePerson.vue?vue&type=script&lang=js"
export * from "./ShowSalePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports